import HODOBaseRequest from '../HODOBaseRequest'

export default class HODORequest extends HODOBaseRequest {
  getHealthCheckService (key) {
    return this.get(`go/customer_service/call-validate/${key}`)
  }
}
